"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Podcast = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
exports.Podcast = {
  name: 'Podcast',
  label: 'Podcast',
  useSites: true,
  table: {
    fieldNames: ["info", "createdBy"]
  },
  list: {
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      id name slug \n      file { \n        id url size type typeName \n        typeImage { id url } \n        formattedSize extension filename \n        thumbnails { \n          id\n          small { id url } \n          large { id url } \n        } \n      }\n    "], ["\n      id name slug \n      file { \n        id url size type typeName \n        typeImage { id url } \n        formattedSize extension filename \n        thumbnails { \n          id\n          small { id url } \n          large { id url } \n        } \n      }\n    "])))
  },
  canCreateInConversation: true,
  form: {
    fieldSets: [{
      name: 'overview',
      label: 'Overview'
    }, {
      name: 'content',
      label: 'Content'
    }, {
      name: 'connections',
      label: 'Connections'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      file: {
        description: 'Choose or link to a file online',
        label: 'File',
        type: 'file',
        required: true
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'PodcastType',
        description: 'What type of {{PODCAST}} is this?'
      },
      banners: {
        type: 'linkedMultiple',
        entityTypeName: 'Banner',
        description: "Provide one or more {{BANNERS}} for this {{PODCAST}}, if required"
      },
      thumbnail: {
        type: 'image'
      },
      summary: {
        type: 'longText',
        description: "Provide a concise summary of this {{PODCAST}} which is shown in cards and listings (this takes priority over Intro and Content for listings)."
      },
      title: {
        type: 'text',
        fieldSet: 'content'
      },
      intro: {
        type: 'longText',
        fieldSet: 'content'
      },
      outro: {
        type: 'longText',
        fieldSet: 'content'
      },
      content: {
        type: 'longText',
        fieldSet: 'content'
      },
      published: {
        type: 'date',
        description: "When was this {{PODCAST}} published? Note: If not specified, the last update of this {{PODCAST}} will be taken as the publish date"
      },
      edited: {
        type: 'date',
        description: "When was this {{PODCAST}} last edited? Note: the record will maintain an Updated date automatically, but this is useful if you'd like to curate a last edited date for display on a website for example."
      },
      authors: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        label: "Authors",
        description: "Does this {{PODCAST}} have any associated authors or presenters?"
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'connections',
        description: 'Select any {{CHALLENGES}} which relate to this {{PODCAST}}'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'connections',
        description: 'Select any {{KEY_ISSUES}} which relate to this {{PODCAST}}'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'connections',
        description: 'Select any {{TRENDS}} which relate to this {{PODCAST}}'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'connections',
        description: 'Select any {{TOPICS}} which relate to this {{PODCAST}}'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'connections',
        description: 'Select any {{SUB_TOPICS}} which relate to this {{PODCAST}}'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      summary { id text }\n      path\n      title\n      subtitle\n      pretitle\n      content { ...ContentNodeFields  }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n      types { ...EntityValueFields }\n      authors { ...EntityValueFields }\n      sites { ...EntityValueFields url }\n      id slug path \n      name \n      title\n      pretitle\n      subtitle\n      published\n      edited\n      content { plain text }\n      openGraph { title description { plain } image { thumbnails { full { url url2x } } } }\n      intro { plain text }\n      outro { text }\n      ...TaxonomyFields\n      authors {\n        id name slug path\n        organisation { id name }\n        linkedin\n        photo { id url url2x }\n        positions {\n          id\n          primary\n          positions {\n            id \n            name \n          }\n          organisation { id name }\n        }\n      }\n      embeds {\n        citations {\n          slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n        }\n        pages {\n          id name slug path\n          openGraph {\n            title description { plain }\n            image { url url2x }\n          }\n        }\n        people {\n          id name slug path\n          organisation { id name }\n          position\n          photo { id url }\n        }\n        imageAssets {\n          id\n          slug\n          image {\n            id url url2x width height\n          }\n        }\n      }\n      banners {\n        id name slug title description { text } alternateText\n        image { \n          id url url2x width height\n        }\n      }\n    "], ["\n      summary { id text }\n      path\n      title\n      subtitle\n      pretitle\n      content { ...ContentNodeFields  }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n      types { ...EntityValueFields }\n      authors { ...EntityValueFields }\n      sites { ...EntityValueFields url }\n      id slug path \n      name \n      title\n      pretitle\n      subtitle\n      published\n      edited\n      content { plain text }\n      openGraph { title description { plain } image { thumbnails { full { url url2x } } } }\n      intro { plain text }\n      outro { text }\n      ...TaxonomyFields\n      authors {\n        id name slug path\n        organisation { id name }\n        linkedin\n        photo { id url url2x }\n        positions {\n          id\n          primary\n          positions {\n            id \n            name \n          }\n          organisation { id name }\n        }\n      }\n      embeds {\n        citations {\n          slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n        }\n        pages {\n          id name slug path\n          openGraph {\n            title description { plain }\n            image { url url2x }\n          }\n        }\n        people {\n          id name slug path\n          organisation { id name }\n          position\n          photo { id url }\n        }\n        imageAssets {\n          id\n          slug\n          image {\n            id url url2x width height\n          }\n        }\n      }\n      banners {\n        id name slug title description { text } alternateText\n        image { \n          id url url2x width height\n        }\n      }\n    "])))
  },
  select: {
    maxWidth: '400px'
  },
  autoRoutes: ['list', 'create', 'update']
};
var templateObject_1, templateObject_2;